import $ from 'jquery';

export default {
  init() {
    // JavaScript to be fired on all pages
    this.teamToggle();

    //Initalise all slick sliders
    var sliders = $('.slick-slider');
    sliders.each(function() {
      $(this).slick();
    });

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
  teamToggle() {
    $('section.team .toggl').on('click', (e) => {
      $(e.currentTarget).siblings('.member__description').slideToggle(1000);
      $(e.currentTarget).toggleClass('open');

      e.preventDefault();
    });
  },
};



// WEBPACK FOOTER //
// /opt/atlassian/pipelines/agent/build/web/app/themes/main-theme/resources/assets/scripts/routes/common.js